export var KeycloakEventPatterns;
(function (KeycloakEventPatterns) {
    KeycloakEventPatterns["KEYCLOAK_USER_EMAIL_CHANGED"] = "KEYCLOAK_USER_EMAIL_CHANGED";
    KeycloakEventPatterns["KEYCLOAK_USER_REGISTER"] = "KEYCLOAK_USER_REGISTER";
    KeycloakEventPatterns["KEYCLOAK_USER_DELETE"] = "KEYCLOAK_USER_DELETE";
    KeycloakEventPatterns["KEYCLOAK_SYNC_USER_ID"] = "KEYCLOAK_SYNC_USER_ID";
    KeycloakEventPatterns["KEYCLOAK_NOTIFY_END_SESSION"] = "KEYCLOAK_NOTIFY_END_SESSION";
    KeycloakEventPatterns["KEYCLOAK_INVITE_RECOVERY_REQUESTED"] = "KEYCLOAK_INVITE_RECOVERY_REQUESTED";
})(KeycloakEventPatterns || (KeycloakEventPatterns = {}));
//# sourceMappingURL=keycloak-event-patterns.enum.js.map